import {Component, ElementRef, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeader implements OnInit{

  constructor(private el: ElementRef, private routeManager: Router, private authService: AuthService) { }
  ngOnInit(): void {
    const nativeElement: HTMLElement = this.el.nativeElement,
    parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
  }

  public onLogout() {
    this.authService.logOut();
  }

  public isSuperAdmin(){
    return this.authService.isSuperAdmin();
  }

  public isAdminAcount() {
    return this.authService.isAdminAccount();
  }
  public getFullName() {
    return this.authService.getUserFullName()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-header/app-header.component.ts